import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=1c6abe17&scoped=true&"
import script from "./TagView.vue?vue&type=script&lang=ts&"
export * from "./TagView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6abe17",
  null
  
)

export default component.exports